var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-fixed tw-inset-0 tw-min-h-screen tw-flex tw-items-center tw-justify-center tw-bg-infinity-background-faded-modal tw-backdrop-filter tw-backdrop-blur"},[_c('base-infinity-loading',{staticClass:"tw-w-24"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }